var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vehiculo)?_c('HistorialExpediente',{attrs:{"vehiculo-id":_vm.vehiculo,"orden-id":_vm.orden,"volver":_vm.rutaBuscar}}):_c('HistorialBuscar',{attrs:{"q":_vm.q},on:{"consulta":_vm.alConsultar}})
}
var staticRenderFns = []

export { render, staticRenderFns }